<template>
  <div class="workflow-detail-overlay" @click="$emit('close')">
    <div class="workflow-detail-container" @click.stop>
      <div class="workflow-detail-header">
        <div class="workflow-detail-title-section">
          <h2 class="workflow-detail-title">{{ workflow.title }}</h2>
          <TagTypeComponent v-if="workflow.level" :tagType="workflow.level" />
        </div>
        <button class="workflow-detail-close" @click="$emit('close')">
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>
      
      <div class="workflow-detail-content">
        <div class="workflow-header">
          <div class="workflow-header-image">
            <img :src="$getProxyUrl(workflow.example_image)" :alt="workflow.title" class="workflow-detail-img">
            <div class="workflow-label">
              {{ workflow.label_name }}
            </div>
          </div>
          <div class="workflow-header-info">
            <p class="workflow-detail-description">{{ workflow.description }}</p>
            <div class="workflow-meta">
              <span class="downloads"><font-awesome-icon :icon="['fas', 'download']" /> {{ workflow.download_count }} 次下载</span>
            </div>
            <div class="workflow-actions">
              <button class="btn btn-primary btn-large" @click="handleDownload">立即下载</button>
            </div>
          </div>
        </div>
        <!-- 视频演示 -->
        <div class="workflow-section">
          <h3 class="section-title">视频演示</h3>
          <div class="section-content">
            <div class="video-container" style="display: flex; justify-content: center;">
              <video :src="workflow.example_video" controls style="width: 100%;"></video>
            </div>
          </div>
        </div>
        <!-- 开始节点 -->
        <div class="workflow-section" v-if="workflow.ext.startNode">
          <h3 class="section-title">开始节点</h3>
          <div class="section-content">
            <div class="image-container" style="display: flex; justify-content: center;">
              <img :src="$getProxyUrl(workflow.ext.startNode)" :alt="workflow.title" class="workflow-detail-img">
            </div>
          </div>
        </div>
        <!-- 结束节点 -->
        <div class="workflow-section" v-if="workflow.ext.endNode">
          <h3 class="section-title">结束节点</h3>
          <div class="section-content">
            <div class="image-container" style="display: flex; justify-content: center;">
              <img :src="$getProxyUrl(workflow.ext.endNode)" :alt="workflow.title" class="workflow-detail-img">
            </div>
          </div>
        </div>
        <!-- 补充内容 -->
        <div class="workflow-section" v-if="workflow.ext.extraContent">
          <h3 class="section-title">补充内容</h3>
          <div class="section-content">
            <div class="image-container" style="display: flex; justify-content: center;">
              <img :src="$getProxyUrl(workflow.ext.extraContent)" :alt="workflow.title" class="workflow-detail-img">
            </div>
          </div>
        </div>
        <!-- 工作流介绍 -->
        <div class="workflow-section">
          <h3 class="section-title">工作流介绍</h3>
          <div class="section-content">
            <pre class="code-block"><code>{{ workflow.description }}</code></pre>
          </div>
        </div>
        <!-- 注意内容 -->
        <div class="workflow-section" v-if="workflow.ext.noticeContent">
          <h3 class="section-title">注意内容</h3>
          <div class="section-content">
            <pre class="code-block"><code>{{ workflow.ext.noticeContent}}</code></pre>
          </div>
        </div>

        <!-- 操作步骤 -->
        <div class="workflow-section">
          <h3 class="section-title">操作步骤</h3>
          <div class="section-content">
            <div class="steps-list">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h4>导入工作流</h4>
                  <p>下载工作流文件后，在相关软件中导入该工作流。</p>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h4>配置参数</h4>
                  <p>根据您的具体需求，配置工作流的相关参数。</p>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h4>执行工作流</h4>
                  <p>点击执行按钮，工作流将自动完成相关操作。</p>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">4</div>
                <div class="step-content">
                  <h4>查看结果</h4>
                  <p>工作流执行完成后，查看生成的结果。</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 系统要求 -->
        <div class="workflow-section">
          <h3 class="section-title">系统要求</h3>
          <div class="section-content">
            <ul class="requirements-list">
              <li>操作系统：Windows 10 或 macOS 10.15 及以上</li>
              <li>相关软件：最新版本</li>
              <li>内存：8GB 及以上</li>
              <li>存储空间：1GB 可用空间</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagTypeComponent from '../components/TagTypeComponent.vue'
import { api } from '../api/index.js'

export default {
  name: 'WorkflowDetail',
  components: {
    TagTypeComponent
  },
  props: {
    workflow: {
      type: Object,
      required: true
    },
    labels: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close'],
  methods: {
    async handleDownload() {
      try {
        const urls = await api.workflow.getDownload(this.workflow.id)
        if (urls && urls.length > 0) {
          urls.forEach(url => {
            window.open(url, '_blank')
          })
        } else {
          alert('暂无下载链接')
        }
      } catch (error) {
        console.error('下载失败:', error)
        alert('下载失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.workflow-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.workflow-detail-container {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 1000px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.workflow-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
}

.workflow-detail-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.workflow-detail-title {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
  flex: 1;
}

.workflow-detail-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s;
}

.workflow-detail-close:hover {
  background-color: #eee;
  color: #333;
}

.workflow-detail-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

/* 工作流头部信息 */
.workflow-header {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
  padding: 24px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.workflow-header-image {
  position: relative;
  width: 300px;
  height: 225px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #e9ecef;
}

.workflow-header-image .tag-type {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
}

.workflow-detail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.workflow-label {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: rgba(102, 126, 234, 0.9);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  z-index: 2;
}

.workflow-header-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.workflow-detail-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
}

.workflow-meta {
  display: flex;
  gap: 20px;
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

.workflow-meta i {
  margin-right: 5px;
}

.workflow-actions {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.btn-large {
  padding: 14px 28px;
  font-size: 18px;
}

.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover {
  background-color: #5568d3;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #666;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

/* 工作流详情内容 */
.workflow-section {
  margin-bottom: 30px;
}

.workflow-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #667eea;
}

.section-content {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.code-block {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  overflow-x: auto;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

.code-block code {
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* 步骤列表 */
.steps-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.step-number {
  width: 36px;
  height: 36px;
  background-color: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 4px;
}

.step-content {
  flex: 1;
}

.step-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.step-content p {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 要求列表 */
.requirements-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.requirements-list li {
  padding: 8px 0;
  padding-left: 20px;
  position: relative;
  font-size: 15px;
  color: #666;
}

.requirements-list li:before {
  content: "•";
  color: #667eea;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-detail-container {
    max-width: 95vw;
  }
  
  .workflow-detail-header {
    padding: 16px;
  }
  
  .workflow-detail-title {
    font-size: 20px;
  }
  
  .workflow-detail-content {
    padding: 16px;
  }
  
  .workflow-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
  }
  
  .workflow-header-image {
    width: 100%;
    max-width: 400px;
  }
  
  .workflow-actions {
    justify-content: center;
  }
  
  .section-title {
    font-size: 18px;
  }
  
  .btn-large {
    padding: 12px 20px;
    font-size: 16px;
  }
  
  .step-item {
    flex-direction: column;
    gap: 10px;
  }
  
  .step-number {
    margin-top: 0;
  }
}
</style>